import { render, staticRenderFns } from "./contestQuizzort.html?vue&type=template&id=f8d8243c&scoped=true&"
import script from "./contestQuizzort.js?vue&type=script&lang=js&"
export * from "./contestQuizzort.js?vue&type=script&lang=js&"
import style0 from "./contestQuizzort.scss?vue&type=style&index=0&id=f8d8243c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d8243c",
  null
  
)

export default component.exports